import { Directive, ElementRef, HostListener, OnInit, Input } from '@angular/core';
import { DOperacionesMatematicasServicio } from '../servicios/doperaciones-matematicas.servicio';


@Directive({
    selector: '[formatoMoneda]'
})
export class FormatoMonedaDirectiva implements OnInit {
  
    private SEPARADOR_DECIMAL:string;
    private VALOR_REDONDEO_MENOR:number = 500;
    
    private el: HTMLInputElement;

    @Input('redondear') redondear:boolean; 
  
    constructor(
        private elementRef: ElementRef,
        private dutilidades:DOperacionesMatematicasServicio
    ) { 
        this.el = this.elementRef.nativeElement;
    }
    
    ngOnInit() {    
        if(this.el.value){
            this.ejecutarProceso(this.el.value);           
        }
    }
    
    @HostListener("focus", ["$event.target.value"])
    onFocus(value) {  
        this.el.value = this.dutilidades.deshacerFormatoMoneda(value);        
    }

    @HostListener("blur", ["$event.target.value"])
    onBlur(value) {
        this.ejecutarProceso(value);      
    }
    
    @HostListener("keypress", ["$event"])
    onKeyup(event) {
        const patronNumeros = /[0-9]|[\.]/;
        let caracter = String.fromCharCode(event.charCode);  
        if (!patronNumeros.test(caracter)) {            
            // validacion para mozilla
            if (!event.ctrlKey && !event.altKey && !event.metaKey) { // validacion de presion de ctrl | alt | command
                // permite teclas como flechas, backspace, supr, tab, punto
                if (
                    !((event.keyCode < 97 || event.keyCode > 122) && 
                    (event.keyCode < 65 || event.keyCode > 90) && 
                    (event.keyCode != 45) && 
                    (event.charCode != 46) && 
                    (event.keyCode != 32) && 
                    (event.keyCode != 0))
                ) {
                    event.preventDefault();
                }
            }
        }
    }

    /**
    * @desc Función para verificar el parametro de la directiva y ejecutar el proceso correspondiente
    * @param {String|Number} value
    */
    private ejecutarProceso(value:any){
        if (this.redondear) {
            this.redondearValor(value);
        } else {
            this.formatearValor(value);
        }
    }
         
    /**
    * @desc Funcion que transforma el valor de la casilla
    * @param {String} value
    * @ignore
    */
    private formatearValor(valor:string) {   
        let valorCasilla = this.dutilidades.validarValorNumerico(valor) ? valor : this.dutilidades.obtenerSoloNumeros(valor);
        this.el.value = this.dutilidades.obtenerFormatoMoneda(valorCasilla);
    }

    /**
    * @desc Funcion que redondea el valor de la casilla
    * @param {String} value
    * @ignore
    */
    private redondearValor(value:string){
        this.el.value = this.dutilidades.redondearValorMoneda(value, true);
    }

}


// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/recibo-pago/src/directivas/formato-moneda.directive.ts